/*
 * パスワード再発行（api getOne)
 */
import { apiGetOne } from '@/actions/ApiBaseActions';
export const API_GET_ONE_USER_PASSWORD_RESET = 'API_GET_ONE_USER_PASSWORD_RESET';
export const API_GET_ONE_USER_PASSWORD_RESET_SUCCESS = 'API_GET_ONE_USER_PASSWORD_RESET_SUCCESS';
export const API_GET_ONE_USER_PASSWORD_RESET_FAILURE = 'API_GET_ONE_USER_PASSWORD_RESET_FAILURE';
/**
 * パスワード再設定
 */
export const apiGetOneUserPasswordReset = ({ path: { token } }, meta) => apiGetOne(API_GET_ONE_USER_PASSWORD_RESET, `/user/password_reset/${token}`, Object.assign(Object.assign({}, meta), { isSnakeCase: true }));
